import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBrandVariant',
})
export class FilterBrandVariantPipe implements PipeTransform {
  transform(items: any[], searchText: string, meta?: { count?: number; key?: string }): any[] {
    if (!items) return [];

    if (!searchText) {
      meta ? (meta.count = items.length) : undefined;
      return items;
    }

    if (searchText.length < 3) return items;

    const _item: any[] = [];
    items.filter((item) => {
      let isHaveSearch = false;
      item.variants.map((variant: any) => {
        isHaveSearch = Object.keys(variant).some((key) => {
          let _k = meta && meta.key ? meta.key : key;
          return String(variant[_k]).toLowerCase().includes(searchText.toLowerCase());
        });
      });
      if (isHaveSearch) {
        _item.push(item);
      }
    });

    meta ? (meta.count = _item.length) : undefined;
    return _item;
  }
}
